import React from 'react';
import Title from '../../components/title/Title';
import './Duvidas.css';

const Duvidas = props => {
    return (
        <div className="background">
            <Title title="Dúvidas" />
            <div className="container">
                <div className="content">
                <div className="question">Estamos em construção...</div>
                    {/* <div className="question">Como revender?</div>
                    <div className="answer">Lorem ipsum dolor sit amet,  diam ut imperdiet. Curabitur nec tristique tortor. Vivamus quis vestibulum nisi. Nulla sit amet mi nibh. Etiam nec aliquam nunc.</div>
                    <div className="question">Como revender?</div>
                    <div className="answer">Lorem ipsum dolor sit amet,  diam ut imperdiet. Curabitur nec tristique tortor. Vivamus quis vestibulum nisi. Nulla sit amet mi nibh. Etiam nec aliquam nunc.</div> */}
                </div>
            </div>
        </div>
    )
};

export default Duvidas;